/**
 * Builds a URL-safe slug from an agency name.
 * Example: "North Wind Agency" → "north-wind-agency"
 */
export function slugifyAgencyName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
